// Notification Message
export const GET_NOTIFICATION_MESSAGES =
  'notification_message/GET_NOTIFICATION_MESSAGES';
export const SET_NOTIFICATIONS_MESSAGE_UNREAD =
  'notification_message/SET_NOTIFICATIONS_MESSAGE_UNREAD';
export const SET_NOTIFICATIONS_MESSAGE_SEEN =
  'notification_message/SET_NOTIFICATIONS_MESSAGE_SEEN';
export const NOTIFICATIONS_MESSAGE_SEEN =
  'notification_message/NOTIFICATIONS_MESSAGE_SEEN';
export const LOAD_NOTIFICATIONS = 'notification_message/LOAD_NOTIFICATIONS';
